/** The old Order Placement screen: now the Reorder Level report, ordered from each row (2026-10-30). */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stores/reorder")({
  beforeLoad: () => {
    throw redirect({
      to: "/stores/reports/$key",
      params: { key: "reorder-level" },
    });
  },
});
